import { render, staticRenderFns } from "./guidepage.vue?vue&type=template&id=45c52890&scoped=true&"
import script from "./guidepage.vue?vue&type=script&lang=js&"
export * from "./guidepage.vue?vue&type=script&lang=js&"
import style0 from "./guidepage.vue?vue&type=style&index=0&id=45c52890&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c52890",
  null
  
)

export default component.exports